<app-spinner></app-spinner>

<div class="app-container">
  @if (isLoggedIn) {
  <div class="position-relative">
    <div class="sidebar" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }">
      <div class="sidebar-header">
        <a href="#" class="sidebar-logo">{{ isSidebarCollapsed ? 'M' : 'MIF Admin' }}</a>
      </div>
      <div class="sidebar-menu">
        <ul>
          <ng-container *ngFor="let item of menuItems">
            <li class="sidebar-menu-item">
              <a
                routerLink="{{ item.link }}"
                [routerLinkActive]="['active-link']"
                class="sidebar-item"
                [ngClass]="{
                  'has-children': item.children,
                  'menu-item-active': item.isOpen
                }"
                (click)="toggleMenuItem(item)"
              >
                <mat-icon mat-list-icon>{{ item.icon }}</mat-icon>
                <span class="sidebar-item-text">{{ item.label }}</span>
                <!-- <i
                  *ngIf="item.children && !isSidebarCollapsed"
                  class="fas fa-chevron-down sidebar-item-arrow"
                  [ngClass]="{ rotated: item.isOpen }"
                ></i> -->
              </a>

              <ul *ngIf="item.children && !isSidebarCollapsed && item.isOpen" class="sidebar-submenu">
                <li *ngFor="let child of item.children">
                  <a href="#" class="sidebar-item sidebar-subitem">
                    <i [class]="child.icon"></i>
                    <span class="sidebar-item-text">{{ child.label }}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
    <button
      class="sidebar-toggle-btn"
      [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }"
      (click)="onSidebarToggle()"
    >
      <mat-icon *ngIf="!isSidebarCollapsed" mat-list-icon>keyboard_arrow_left</mat-icon>
      <mat-icon *ngIf="isSidebarCollapsed" mat-list-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div>
  }

  <main class="content" [ngClass]="{ 'content-expanded': isSidebarCollapsed, 'content-full-width': !isLoggedIn }">
    <div class="content-inner">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
